import React from 'react';
import { HeroSection } from './components/HeroSection';
import { HiddenKnowledgeSection } from './components/HiddenKnowledgeSection';
import { PainSection } from './components/PainSection';
import { ReframeSection } from './components/ReframeSection';
import { MicroTranceSection } from './components/MicroTranceSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { HeadScripts } from './components/HeadScripts';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  return <div className="font-sans bg-white" data-id="element-0">
      <HeadScripts data-id="element-1" />
      <HeroSection data-id="element-2" />
      <HiddenKnowledgeSection data-id="element-3" />
      <PainSection data-id="element-4" />
      <ReframeSection data-id="element-5" />
      <MicroTranceSection data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <FinalCTASection data-id="element-8" />
      <Footer data-id="element-9" />
      <PurchaseNotification data-id="element-10" />
    </div>;
}